export const TABLE_DATA_REQUEST = 'TABLE_DATA_REQUEST'
export const TABLE_DATA_SUCCESS = 'TABLE_DATA_SUCCESS'
export const TABLE_DATA_FAILURE = 'TABLE_DATA_FAILURE'

export const TABLE_META_SET = 'TABLE_META_SET'
export const TABLE_META_PATCH = 'TABLE_META_PATCH'
